export default __webpack_public_path__ + "static/media/T760_RoHS.7b435675.pdf";